export const REST_API_KEY = "5ddb169e52f0431aef4f350d977f08f6";

// 실행 중인 페이지 주소 기준으로 리다이렉트 URI 사용 (배포/로컬 모두 대응)
export const getRedirectUri = () => {
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}/auth/kakao/callback`;
  }
  return "https://hotel-83914.web.app/auth/kakao/callback";
};

export const REDIRECT_URI = "http://localhost:3000/auth/kakao/callback"; // 하위 호환용, 실제 사용은 getRedirectUri()

export const getKakaoAuthUrl = () =>
  `https://kauth.kakao.com/oauth/authorize?client_id=${REST_API_KEY}&redirect_uri=${encodeURIComponent(getRedirectUri())}&response_type=code&scope=profile_nickname&nonce=random_string`;

export const CLIENT_SECRET = "lmM7IIaPMCHfQMLC1R9PFJlSBXaDimRK";
export const KAKAO_APP_KEY = "3f9601edf4c9bcec7f3aef2dcc8d2bcf";